module.exports = "<monitoring-dashboard [entityIdDetails]=\"entityIdDetails\">Loading...</monitoring-dashboard>"


//////////////////
// WEBPACK FOOTER
// ./src/app/entities/monitoring/entitymonitoringclient/entity-monitoring-client.component.html
// module id = 2248
// module chunks = 0